export default {
  metadata: {
    version: '1.0.0',
    id: 'feedback-block-1.0.0',
    name: 'JDSFeedbackBlock'
  },
  hierarchy: {
    container: [
      {
        'icon-container': ['icon']
      },
      'jds-text'
    ]
  },
  base: {
    container: {
      hidden: true,
      'flex-direction': '{f_0}',
      'justify-content': '{f_1}',
      'align-items': '{f_2}',
      gap: '{f_3}'
    },
    'icon-container': {
      'flex-direction': '{f_5}',
      'justify-content': '{f_6}',
      'align-items': '{f_7}',
      height: '{f_8}'
    },
    icon: {
      size: '{f_9}'
    },
    'jds-text': {
      'font-family': '{text_132}',
      color: '{text_20}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    size: {
      s: {
        'icon-container': {
          height: '{f_10}'
        },
        icon: {
          size: '{f_11}'
        },
        'jds-text': {
          'font-family': '{text_147}',
          'font-size': '{text_146}',
          'line-height': '{text_148}',
          'letter-spacing': '{text_149}',
          'font-weight': '{text_150}'
        }
      }
    },
    state: {
      success: {
        container: {
          hidden: false
        },
        icon: {
          value: 'ic_success_colored',
          color: '{feedbackSuccess50}'
        },
        'jds-text': {
          color: '{text_59}'
        }
      },
      error: {
        container: {
          hidden: false
        },
        icon: {
          value: 'ic_error_colored',
          color: '{feedbackError50}'
        },
        'jds-text': {
          color: '{text_53}'
        }
      },
      warning: {
        container: {
          hidden: false
        },
        icon: {
          value: 'ic_warning_colored',
          color: '{feedbackWarning50}'
        },
        'jds-text': {
          color: '{text_56}'
        }
      }
    },
    alignment: {
      top: {
        container: {
          'align-items': '{f_4}'
        }
      }
    }
  },
  api: {
    config: {
      size: {
        values: ['l', 's']
      },
      state: {
        values: ['none', 'success', 'error', 'warning']
      },
      alignment: {
        values: ['center', 'top']
      }
    },
    data: {
      'jds-text': {
        value: {
          type: 'string',
          name: 'stateText'
        }
      }
    }
  }
};
